import React, { useState, useEffect, useContext } from 'react';
import { PostData } from './data/Fetch';
import Dropdown from './Dropdown';
import SkuDropdown from './SkuDropdown';
import MoreInfoModal from './MoreInfoModal';
import BuyArea from './BuyArea';
import Accordion from './Accordion';
import { SettingsContext, TranslationContext } from './Context';
import ReactHtmlParser from 'react-html-parser';

const VariantPicker = props => {
    const settings = useContext(SettingsContext);
    const translations = useContext(TranslationContext);
    const [attributes, setAttributes] = useState(props.attributes);
    const [showSkuInfo, setShowSkuInfo] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [imageUrl, setImageUrl] = useState(props.imageUrl);
    const [imageAlt, setImageAlt] = useState(props.imageAlt);
    const [showIA, setShowIA] = useState(false);
    const [showOA, setShowOA] = useState(false);
    const [showLoader, setShowLoader] = useState(false);
    const [showSkuDD, setShowSkuDD] = useState(false);
    const [skuOptions, setSkuOptions] = useState(null);
    const [selectedSku, setSelectedSku] = useState(props.selectedSku);

    const [showError, setShowError] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    useEffect(() => {
        if (attributes.findIndex(x => x.Options) === -1) {
            const headers = {
                'X-sc-contextitemid': settings.contextitemid,
                'X-sc-language': settings.language,
                'X-edometiccontext': settings.isEDometicContext,
                'Content-Type': 'application/json'
            };

            PostData(`/options`, settings.selections, headers)
                .then(data => {
                    if (data === "NoAttributes") {
                        setErrorMessage("Something went wrong! No attributes available.");
                        setShowError(true);
                    } else if (data === "NoSkus") {
                        setErrorMessage("Something went wrong! No valid skus available.");
                        setShowError(true);
                    } else if (data === "NoNextAttribute") {
                        setErrorMessage("Something went wrong! Next attribute is not available.");
                        setShowError(true);
                    } else {
                        const nextId = data[0].attributeId;
                        let newData = data;
                        if (settings.skuoptions.length > 0) {
                            const correctOption = settings.skuoptions.find(x => x.AttributeId === nextId);
                            newData = data.map(x => x.value === correctOption.Value ? { ...x, selected: true } : x);
                        }

                        const newAttributes = attributes.map(x => x.AttributeId === nextId ? { ...x, Options: newData } : x);
                        setAttributes(newAttributes);
                    }
                });
        } else if (showSkuDD && settings.selectedsku && selectedSku === "default" && skuOptions && skuOptions.some(x => x.key === settings.selectedsku)) {
            skuSelectionHandler(settings.selectedsku);
        }
    }, [attributes, selectedSku]);

    const skuSelectionHandler = (selectedValue) => {
        const headers = {
            'X-sc-contextitemid': settings.contextitemid,
            'X-sc-language': settings.language,
            'X-edometiccontext': settings.isEDometicContext,
            'Content-Type': 'application/json'
        };

        setShowLoader(true);
        const skuSelection = [];
        skuSelection.push({ index: -1, attributeId: "sku", solrFieldName: "sku", selectedOption: selectedValue });
        return PostData(`/sku`, skuSelection, headers)
            .then(data => {
                setSelectedSku(selectedValue);
                addSkuData(data);
                setShowLoader(false);
            });
    };

    const selectionHandler = (index, id, fieldName, selectedValue) => {
        if (settings.selections.find(x => x.index === index)?.selectedOption === selectedValue) return;
        if (settings.selections.length > 0) settings.selections = settings.selections.filter(x => x.index < index);
        settings.selections.push({ index: index, attributeId: id, solrFieldName: fieldName, selectedOption: selectedValue });

        const headers = {
            'X-sc-contextitemid': settings.contextitemid,
            'X-sc-language': settings.language,
            'X-edometiccontext': settings.isEDometicContext,
            'Content-Type': 'application/json'
        };

        if (attributes.every(x => settings.selections.findIndex(y => y.attributeId === x.AttributeId) !== -1)) {
            disableDropdowns(true);
            setShowLoader(true);

            return PostData(`/sku`, settings.selections, headers)
                .then(data => {
                    if (data === "NoValidSkus") {
                        setErrorMessage("Something went wrong! No valid skus.");
                        setShowError(true);
                    } else if (data === "SomethingWentWrong") {
                        setErrorMessage("Something went wrong!");
                        setShowError(true);
                    } else {
                        const newAttributes = attributes.map(x =>
                            x.AttributeId === id ? { ...x, Options: x.Options.map(o => o.value === selectedValue ? { ...o, selected: true } : { ...o, selected: false }) } : x);
                        setAttributes(newAttributes);

                        if (data.constructor === Array) {
                            setSkuOptions(data);
                            setShowSkuDD(true);
                            setShowLoader(false);
                            disableDropdowns(false);
                        } else {
                            addSkuData(data);
                            setShowLoader(false);
                            disableDropdowns(false);
                        }
                    }
                });
        } else {
            resetSkuSelection();

            return PostData(`/options`, settings.selections, headers)
                .then(data => {
                    if (data === "NoAttributes") {
                        setErrorMessage("Something went wrong! No attributes available.");
                        setShowError(true);
                    } else if (data === "NoSkus") {
                        setErrorMessage("Something went wrong! No valid skus available.");
                        setShowError(true);
                    } else if (data === "NoNextAttribute") {
                        setErrorMessage("Something went wrong! Next attribute is not available.");
                        setShowError(true);
                    } else {
                        if (data.length > 0) {
                            const nextId = data[0].attributeId;

                            if (data.length === 1) {
                                data[0].selected = true;
                            } else if (settings.skuoptions.length > 0) {
                                data.find(o => o.value === settings.skuoptions.find(x => x.AttributeId === nextId).Value).selected = true;
                            }

                            const newAttributes = attributes.map(x =>
                                x.AttributeId === nextId ? { ...x, Options: data } :
                                    settings.selections.findIndex(y => y.attributeId === x.AttributeId) === -1 ? { ...x, Options: null } :
                                        x.AttributeId === id ? { ...x, Options: x.Options.map(o => o.value === selectedValue ? { ...o, selected: true } : { ...o, selected: false }) } : x);

                            setAttributes(newAttributes);
                            removeSkuData();
                        }
                    }
                });
        }
    };

    const disableDropdowns = (trueorfalse) => {
        var list, index;
        list = document.getElementsByClassName("variantPickerComponent-dropdown");
        for (index = 0; index < list.length; ++index) {
            list[index].disabled = trueorfalse;
        }
    };

    const resetSkuSelection = () => {
        setSkuOptions(null);
        setShowSkuDD(false);
        setSelectedSku("default");
    };
    const addSkuData = (data) => {
        settings.skuoptions = [];
        settings.skudata = data;
        setImageUrl(data.imageUrl);
        setImageAlt(data.imageAlt);
        setShowSkuInfo(true);
        setShowIA(settings.skudata.installationAccessories && settings.skudata.installationAccessories.length > 0);
        setShowOA(settings.skudata.optionalAccessories && settings.skudata.optionalAccessories.length > 0);

        var newRelativePathQuery = window.location.pathname + '?sku=' + data.skuId;
        history.pushState(null, '', newRelativePathQuery);      

        /*
        if (typeof ga4TagEcommerceHelper != 'undefined') {
            ga4TagEcommerceHelper.measureProductDetailViews({
                'item_id': data.skuNumber,
                'item_name': data.name,
                'item_category': data.category?.item_category,
                'item_category2': data.category?.item_category2,
                'item_category3': data.category?.item_category3,
                'item_brand': 'dometicforbusiness',
                'price': data.priceUnformatted
            });
        }
        */
    };
    const removeSkuData = () => {
        setShowIA(false);
        setShowOA(false);
        setShowSkuInfo(false);
        setShowModal(false);
        settings.skudata = [];
    };

    const handleClose = () => {
        setShowModal(false);
    };

    const addToCartHandler = (skuNumber,name, skuId, originalSkuNumber, modelId, quantity, openModal, category, priceUnformatted) => {
        const headers = {
            'X-sc-contextitemid': settings.contextitemid,
            'X-sc-language': settings.language,
            'Content-Type': 'application/json'
        };

        const body = {
            skuNumber: skuNumber,
            skuId: skuId,
            originalSkuNumber: originalSkuNumber,
            modelId: modelId,
            quantity: quantity
        };

        if (typeof ga4TagEcommerceHelper != 'undefined') {
            ga4TagEcommerceHelper.measureAddToCart({
                'item_id': skuNumber,
                'item_brand': 'dometicforbusiness',              
                'quantity': quantity,
                'item_name': name,
                'price': priceUnformatted,
                'item_category': category?.item_category,
                'item_category2': category?.item_category2,
                'item_category3': category?.item_category3,
            });
        }

        //ga4TagEcommerceHelper.measureAddToCart({
        //    'item_id': eDometicGtagManager.formatId($item.data("id")),
        //    'item_name': eDometicGtagManager.formatName($item.data("name")),
        //    'item_category': $item.data("category"),
        //    'price': eDometicGtagManager.formatPrice($item.data("price")),
        //    'quantity': quantity
        //}, $item.data("currencycode"));

        return PostData(`/cart`, body, headers)
            .then(data => {
                if (data) {
                    if (updateCartIcon) {
                        if (data.success) {
                            updateCartIcon(data.totalCartQuantity);
                            if (!showIA) {
                                showAddedToCartMessage();
                            }
                        }
                        else {
                            updateCartIcon(data);
                        }
                    }
                }

                if (openModal && showIA && !showModal) {
                    setShowModal(true);
                }
            });
    };

    const updateCartIcon = (numberOfItemsInCart) => {
        var hasItemsInCart = numberOfItemsInCart > 0;

        $('.navigationMainComponent-cartQuantity').each(function () {
            if (hasItemsInCart) {
                this.innerHTML = numberOfItemsInCart;
            }
            toggleElement($(this), hasItemsInCart);
        });

        $('.navigationMainComponent-cartWithItems').each(function () {
            toggleElement($(this).closest(".navigationMainComponent-cartWrapper"), hasItemsInCart);
        });
        $('.navigationMainComponent-cart').each(function () {
            toggleElement($(this).closest(".navigationMainComponent-cartWrapper"), !hasItemsInCart);
        });
        $('.navigationMainComponent-cartWithItemsMobile').each(function () {
            toggleElement($(this).parent(), hasItemsInCart);
        });
        $('.navigationMainComponent-cartWithItemsMobile').each(function () {
            toggleElement($(this), hasItemsInCart);
        });
        $('.navigationMainComponent-cartMobile').each(function () {
            toggleElement($(this), !hasItemsInCart);
        });
    };

    const toggleElement = ($element, boolean) => {
        if ($element) {
            if (boolean) {
                $element.show();
            } else {
                $element.hide();
            }
        }
    };

    const dropdownDisabled = (options) => {
        if (options) {
            return options.length < 1;
        }
        else return true;
    };
    const getPromotionBadge = () => {
        if (props.promotionBadge) {
            const promotionBadgeNew = translations["VariantPicker.PromotionBadgeNew"];
            const promotionBadgeComingSoon = translations["VariantPicker.PromotionBadgeComingSoon"];

            let badge = props.promotionBadge === promotionBadgeNew ? promotionBadgeNew :
                promotionBadgeComingSoon;

            return <p className="variantPickerComponent-modelPromotionBadge" >{badge}</p>;
        }
        return "";
    };

    return (
        <div className="variantPickerComponent">
            <div className="variantPickerComponent-backgroundImage">
                <div className="variantPickerComponent-container container">
                    <div className="col-sm-4 variantPickerComponent-imageContainer">
                        <img className="variantPickerComponent-productImg img-responsive" src={imageUrl} alt={imageAlt} />
                        {
                            settings.skudata?.isShowingSimilarImage &&
                            <div className="variantPickerComponent-productImageMeta">
                                <span className="variantPickerComponent-productImageMetaContainer">
                                    {ReactHtmlParser(settings.similarImageSvg)}
                                </span>
                                <span>{translations["VariantPicker.IsShowingSimilarImage"]}</span>
                            </div>
                        }
                    </div>
                    <div className="col-sm-8 variantPickerComponent-pickerContainer">
                        {getPromotionBadge()}
                        <h1 className="variantPickerComponent-modelTitle">{props.modelTitle}</h1>
                        <p className="variantPickerComponent-modelText u-muted">{props.modelText}</p>

                        <div className="variantPickerComponent-selectContainer">
                            {
                                Object.keys(attributes).map((x, index) => (
                                    <Dropdown label={attributes[x].Title} id={attributes[x].AttributeId} index={index} fieldName={attributes[x].SolrFieldName} onChange={selectionHandler} disabled={dropdownDisabled} options={attributes[x].Options} />
                                ))
                            }
                            {showSkuDD && <SkuDropdown label="Sku" id="skuDD" index="-1" fieldName="skuDD" onChange={skuSelectionHandler} options={skuOptions} selectedValue={selectedSku} />}
                        </div>

                        <div className="variantPickerComponent-buyAreaContainer">
                            {showLoader && <div className="variantPickerComponent-buyAreaLoader"><div className="variantPickerComponent-loading" /></div>}
                            {showSkuInfo && <a href={settings.skudata.url} className="variantPickerComponent-moreInfo btn btn-white">{translations["VariantPicker.ShowMoreInfoButtonText"]}</a>}
                            {showSkuInfo && <BuyArea addToCart={addToCartHandler} />}
                            {showError && <span className="variantPickerComponent-errorMessage">{errorMessage}</span>}
                        </div>
                    </div>
                </div>
            </div>

            {showIA && <Accordion addToCart={addToCartHandler} data={settings.skudata.installationAccessories} buttonText={translations["VariantPicker.InstallationAccessoriesButtonText"]} title={translations["VariantPicker.InstallationAccessoriesTitle"]} description={translations["VariantPicker.InstallationAccessoriesText"]} />}
            {showOA && <Accordion addToCart={addToCartHandler} data={settings.skudata.optionalAccessories} buttonText={translations["VariantPicker.OptionalAccessoriesButtonText"]} title={translations["VariantPicker.OptionalAccessoriesTitle"]} description={translations["VariantPicker.OptionalAccessoriesText"]} />}
            {showModal && <MoreInfoModal showModal={showModal} handleClose={handleClose.bind(this)} addToCart={addToCartHandler} />}
        </div>
    );
};

export default VariantPicker;
